import { LinguagemEnum } from "shared/enums/LinguagemEnum";

//local storage keys
export const TOKEN = "token";
export const BROWSER_ID = "browser_id";
export const USER = "usuario";
export const TIPO_DIAGNOSTICO_UTILIZADO = "TIPO_DIAGNOSTICO_UTILIZADO";
export const DEFAULT_LANG = LinguagemEnum.Ingles;

//session storage keys
export const QUIZ_INFO = "QUIZ_INFO";
export const HERO_INFO = "HERO_INFO";

export const NOVO_USUARIO = "NOVO_USUARIO";

export const REFERENCE_PAGE = "REFERENCE_PAGE";

export const DISTRO_PARAM = "DISTRO_PARAM";
export const PRICING_PARAM = "PRICING_PARAM";
